import {
    GET_LEAD_PROFILE_REQUEST,
    GET_LEAD_PROFILE_REQUEST_SUCCESS,
    GET_LEAD_PROFILE_REQUEST_FAILURE,
} from '../constants/get_lead_profile.constants';
import { GET_USERS_LIST_SUCCESS, GET_USERS_LIST_FAILURE } from '../../../Manage_retail/redux/constants/get_users_list.constants';
import {
    CREATE_BIKE_HPI_CHECK_FAILURE,
    CREATE_BIKE_HPI_CHECK_SUCCESS,
    GET_BIKE_HPI_CHECK_FAILURE,
    GET_BIKE_HPI_CHECK_SUCCESS,
} from '../constants/bike_hpi_check.constants';
import {
    CREATE_LEAD_PROFILE_LEAD_FINANCE,
    CREATE_LEAD_PROFILE_LEAD_FINANCE_SUCCESS,
    CREATE_LEAD_PROFILE_LEAD_FINANCE_FAILURE,
    READ_LEAD_PROFILE_LEAD_FINANCE,
    READ_LEAD_PROFILE_LEAD_FINANCE_SUCCESS,
    READ_LEAD_PROFILE_LEAD_FINANCE_FAILURE,
} from '../constants/lead_profile_lead_finance.constants';
import { CREATE_ORDER_REQUEST_SUCCESS } from '../constants/create_order.constants';
import {
    CHANGE_LEADS_STATUS_REQUEST,
    CHANGE_LEADS_STATUS_REQUEST_SUCCESS,
    CHANGE_LEADS_STATUS_REQUEST_FAILURE,
    GET_LEADS_STATUS_SUCCESS,
    GET_LEADS_STATUS_FAILURE,
} from '../constants/leads_status.constants';
import {
    ASSIGN_LEAD,
    ASSIGN_LEAD_SUCCESS,
    ASSIGN_LEAD_FAILURE,
    ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT,
    ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_SUCCESS,
    ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_FAILURE,
} from '../../../Manage_retail/redux/constants/assign_lead.constants';
import {
    GET_LEADS_WITH_DUPLICATE_VRM,
} from '../constants/get_bike_duplicates.constants';
import { SET_FINAL_CONFIRMATION_FAILURE, SET_FINAL_CONFIRMATION_SUCCESS, SET_FINAL_CONFIRMATION } from '../constants/final_confirmation.constants';

import { GET_TRANSPORT_USERS_LIST, GET_TRANSPORT_USERS_LIST_SUCCESS, GET_TRANSPORT_USERS_LIST_FAILURE } from '../constants/get_transport_users_list.constants';


const initialState = {
    loading: false,
    lead_profile_data_loading: false,
    vrmDuplicates: {
        isLoading: true,
        vrmsList: [],
    },
    lead_status_list: [],
    is_manager_special: false,
    assign_lead_loading: false,
    assign_lead_delivery_requested_agent_loading: false,
    assignedTo: null,
    deliveryRequestedAgentAssignedTo: null,
    transport_users_loading: false,
    transport_users: null,
    users: null,
    current_status: {},
    current_status_loading: false,
    blemish_report: null,
    bike_hpi_check: null,
    root_id: null,
    price_look_up: null, // unused
    price_look_up_loading: false,
    approval: null,
    lead_transport: null,
    lead_finance: null,
    lead_finance_loading: true,
    pagination: {
        previous_lead_id: null,
        next_lead_id: null,
        isLoading: true,
    },
    is_deleted: false,
    leadomatic: null,
    error: null,
    trade: {},
};

export const Lead_general = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LEAD_DATA':
        return {
            ...state,
            ...action.payload,
        };
    case GET_LEADS_STATUS_SUCCESS:
        return {
            ...state,
            lead_status_list: action.lead_status_list,
        };
    case GET_LEADS_STATUS_FAILURE:
        return {
            ...state,
            lead_status_list: [],
            error: action.error,
        };
    case GET_LEADS_WITH_DUPLICATE_VRM:
        return {
            ...state,
            vrm_loading: true,
        };
    case 'RESET_LEADS':
        return {
            ...state,
            loading: false,
        };
        // ASSIGN LEAD
    case ASSIGN_LEAD:
        return {
            ...state,
            assign_lead_loading: true,
        };
    case ASSIGN_LEAD_SUCCESS:
        return {
            ...state,
            assign_lead_loading: false,
            assignedTo: action.payload,
        };
    case ASSIGN_LEAD_FAILURE:
        return {
            ...state,
            assign_lead_loading: false,
        };

        // ASSIGN LEAD Delivery Requested Agent
    case ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT:
        return {
            ...state,
            assign_lead_delivery_requested_agent_loading: true,
        };
    case ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_SUCCESS:
        return {
            ...state,
            assign_lead_delivery_requested_agent_loading: false,
            deliveryRequestedAgentAssignedTo: action.payload,
        };
    case ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_FAILURE:
        return {
            ...state,
            assign_lead_delivery_requested_agent_loading: false,
        };

        // LEAD STATUSES
    case CHANGE_LEADS_STATUS_REQUEST:
        return {
            ...state,
            current_status_loading: true,
        };
    case CHANGE_LEADS_STATUS_REQUEST_SUCCESS:
        return {
            ...state,
            current_status_loading: false,
            current_status: action.payload.ref_lead_status,
            approval: action.payload.approval || state.approval,
        };
    case CHANGE_LEADS_STATUS_REQUEST_FAILURE:
        return {
            ...state,
            current_status_loading: false,
            error: action.error,
        };

    case GET_TRANSPORT_USERS_LIST:
        return {
            ...state,
            transport_users_loading: true,
        };
    case GET_TRANSPORT_USERS_LIST_SUCCESS:
        return {
            ...state,
            transport_users: action.payload,
            transport_users_loading: false,

        };
    case GET_TRANSPORT_USERS_LIST_FAILURE:
        return {
            ...state,
            error: action.error,
            transport_users: null,
            transport_users_loading: false,
        };

        // GET USERS
    case GET_USERS_LIST_SUCCESS:
        return {
            ...state,
            users: action.payload,
        };
    case GET_USERS_LIST_FAILURE:
        return {
            ...state,
            error: action.error,
        };

    case CREATE_ORDER_REQUEST_SUCCESS:
        return {
            ...state,
            lead_transport: action.payload,
        };

    case GET_LEAD_PROFILE_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_LEAD_PROFILE_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            is_manager_special: action.is_manager_special ? action.is_manager_special : false,
            assignedTo: action.payload ? action.payload.ref_assigned_to : [],
            deliveryRequestedAgentAssignedTo: action.payload ? action.payload.ref_delivery_requested_assigned_to : null,
            current_status: action.payload ? action.payload.ref_lead_status : [],
            root_id: action.payload ? action.payload._id : [],
            lead_created_date: action.payload ? action.payload.created_date : [],
            ref_lead_source: action.payload ? action.payload.ref_lead_source : [],
            approval: action.payload ? action.payload.approval : [],
            lead_transport: action.payload ? action.payload.lead_transport : [],
            is_deleted: action.payload ? Boolean(action.payload.deleted_date) : [],
            leadomatic: action.payload ? action.payload.leadomatic : [],
            trade: action.payload ? action.payload.trade : {},
        };

    case 'CHECK_APPROVAL':
        return {
            ...state,
            approval: action.payload,
        };

    case CREATE_BIKE_HPI_CHECK_SUCCESS:
        return {
            ...state,
            bike_hpi_check: action.data,
            // approval: ''
        };
    case CREATE_BIKE_HPI_CHECK_FAILURE:
    case GET_LEAD_PROFILE_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };

    case GET_BIKE_HPI_CHECK_SUCCESS:
        return {
            ...state,
            bike_hpi_check: action.payload,
        };
    case GET_BIKE_HPI_CHECK_FAILURE:
        return {
            ...state,
            error: action.error,
        };

    case SET_FINAL_CONFIRMATION:
        return {
            ...state,
            lead_finance_loading: true,
        };

    case SET_FINAL_CONFIRMATION_SUCCESS:
        return {
            ...state,
            lead_finance: action.data,
            lead_finance_loading: false,
        };
    case SET_FINAL_CONFIRMATION_FAILURE:
        return {
            ...state,
            error: action.error,
            lead_finance_loading: false,
        };

    case CREATE_LEAD_PROFILE_LEAD_FINANCE:
        return {
            ...state,
            lead_finance_loading: true,
        };

    case CREATE_LEAD_PROFILE_LEAD_FINANCE_SUCCESS:
        return {
            ...state,
            lead_finance: action.data,
            lead_finance_loading: false,
        };
    case CREATE_LEAD_PROFILE_LEAD_FINANCE_FAILURE:
        return {
            ...state,
            error: action.error,
            lead_finance_loading: false,
        };
    case READ_LEAD_PROFILE_LEAD_FINANCE:
        return {
            ...state,
            lead_finance_loading: true,
            lead_finance: null,
        };

    case READ_LEAD_PROFILE_LEAD_FINANCE_SUCCESS:
        return {
            ...state,
            lead_finance_loading: false,
            lead_finance: action.data,
        };
    case READ_LEAD_PROFILE_LEAD_FINANCE_FAILURE:
        return {
            ...state,
            lead_finance_loading: false,
            lead_finance: null,
            error: action.error,
        };
        // PREV-NEXT Lead feature
    case 'SET_PREV_NEXT_LEAD':
        return {
            ...state,
            pagination: {
                ...state.pagination,
                next_lead_id: action.payload.nextLeadId,
                previous_lead_id: action.payload.prevLeadId,
            },
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_general.reducer.js